import LocalizedStrings from "react-localization";
//{marathi:'mr', hindi:'hi', english:'en', gujrati:'gj'
export default new LocalizedStrings({
    en: {},
    hi: {},
    gj: {},
    mr: {},
});

/*
strings.setContent({
  en:{
    how:"How do you want your egg todajsie?",
    boiledEgg:"Boiled eggsie",
    softBoiledEgg:"Soft-boiled egg",
    choice:"How to choose the egg"
  }
})
# that this will remove all other localizations if used.

----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    setLanguage(languageCode) - to force manually a particular language
    getLanguage() - to get the current displayed language
    getInterfaceLanguage() - to get the current device interface language
    formatString() - formats the input string and returns a new string, replacing its placeholders with the other arguments strings
----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

_onSetLanguageToItalian() {
  strings.setLanguage('it');
  this.setState({});
}

*/
